webpackJsonp([248689675733321],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Banners = __webpack_require__(11);
	
	var _PageHelpers = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var OutdoorGrid = function OutdoorGrid(_ref) {
	  var data = _ref.data;
	
	  var page = data.mortyPage;
	
	  // Filter out Featured Events page
	  var allPages = data.allOutdoors.edges.filter(function (p) {
	    return p.node.title !== 'Featured Events';
	  });
	
	  // If there are events, add them to the data
	  var gridData = allPages.concat(data.allOutdoors.edges);
	
	  // Force ordering
	  var pageRoutes = ['/explore-downtown/outdoors/belle-isle/', '/explore-downtown/outdoors/browns-island/', '/explore-downtown/outdoors/james-river-activities/', '/explore-downtown/outdoors/james-river-park-system/', '/explore-downtown/outdoors/riverfront-public-art/', '/explore-downtown/outdoors/virginia-capital-trail/'];
	
	  var orderedPages = [];
	  pageRoutes.forEach(function (route) {
	    var item = gridData.find(function (obj) {
	      return obj.node.route === route;
	    });
	    if (item) {
	      orderedPages.push(item);
	    }
	  });
	
	  // Filter out undefined values
	  var filteredPages = orderedPages.filter(Boolean);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta2.default, { page: page }),
	    _react2.default.createElement(_Banners.ListGridBannerMinor, { page: page }),
	    _react2.default.createElement(
	      'div',
	      { className: 'pv3 pv4-m pv5-l flex items-center justify-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        filteredPages && filteredPages.map(function (d) {
	          return _react2.default.createElement(_PageHelpers.ListGridItem, { key: d.node.id, page: d.node });
	        })
	      )
	    )
	  );
	};
	
	exports.default = OutdoorGrid;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	var previewQuery = exports.previewQuery = '\nquery OutdoorGrid($id: String!) {\n  mortyPage(id: { eq: $id }) {\n    title\n    route\n    subtitle\n    route\n    metaTitle\n    metaDescription\n    metaKeywords\n  }\n  allOutdoors: allMortyPage(filter: {\n    route: { ne: "/dummy-page" }\n    section: { eq: "Outdoors" }\n}) {\n    edges {\n      node {\n        id\n        title\n        route\n        section\n        abstract\n        template\n        abstractPhotoAltText\n        abstractPhotoFocalPointX\n        metaDescription\n        abstractPhotoFocalPointY\n        abstractPhoto {\n          url\n        }\n      }\n    }\n  }\n}\n';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-outdoor-grid-js-ebf1955ddf332dce656e.js